let messageIndex = 0;

export const getMessageIndex = () => {
  return messageIndex++;
}